import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.regexp.to-string";
import _toConsumableArray from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/toConsumableArray.js";
import "core-js/modules/es6.regexp.split";
import _defineProperty from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import { httpAction, getAction } from '@/api/manage';
import { ACCESS_TOKEN } from '@/store/mutation-types';
import Vue from 'vue';
var columns = [{
  dataIndex: 'itemText',
  title: '网站名称',
  align: "center",
  scopedSlots: {
    customRender: 'itemText'
  },
  sorter: true
}, {
  dataIndex: 'itemValue',
  title: '网站地址',
  align: "center",
  scopedSlots: {
    customRender: 'itemValue'
  },
  sorter: true
}, {
  dataIndex: 'description',
  title: '网站描述',
  align: "center",
  scopedSlots: {
    customRender: 'description'
  },
  sorter: true
}, {
  dataIndex: 'sortOrder',
  title: '排序',
  align: "center",
  scopedSlots: {
    customRender: 'sortOrder'
  },
  sorter: true
}, {
  title: '操作',
  witdh: '120px',
  dataIndex: 'operation',
  align: 'center',
  scopedSlots: {
    customRender: 'operation'
  }
}];
var dataSource = []; // PS相关的KEY不能为title关键字

var addData1Index = 0;
export default {
  name: "DictRouteList",
  mixins: [JeecgListMixin],
  components: {},
  data: function data() {
    this.cacheData1 = dataSource.map(function (item) {
      return _objectSpread({}, item);
    });
    return {
      pagePath: '/sys/dictItem',
      pageTitle: '',
      dictId: '',
      tokenHeader: {
        'X-Access-Token': Vue.ls.get(ACCESS_TOKEN)
      },
      dataSource: dataSource,
      addData1Index: addData1Index,
      columns: columns,
      disabled: false,
      editingKey: '',
      url: {
        list: "/sys/dictItem/list",
        add: '/sys/dictItem/add',
        edit: '/sys/dictItem/edit',
        delete: '/sys/dictItem/delete'
      }
    };
  },
  created: function created() {},
  computed: {},
  watch: {
    // 监听路由对象，路由发生变化时执行方法
    '$route': 'forceRerender'
  },
  methods: {
    forceRerender: function forceRerender() {
      this.loadData();
      this.editingKey = '';
    },
    loadData: function loadData(arg) {
      var ss = this.$route.path.split("/");
      this.dictId = ss[ss.length - 1];
      this.queryParam.dictId = this.dictId; // 取路由后面的dictId

      this.initTableData(arg);
    },
    initTableData: function initTableData(arg) {
      var _this = this;

      if (arg === 1) {
        this.ipagination.current = 1;
      }

      var params = this.getQueryParams(); //查询条件

      params.pageNo = 1;
      params.pageSize = 10000;
      this.loading = true;
      getAction(this.url && this.url.list ? this.url.list : this.pagePath, params).then(function (res) {
        if (res.success) {
          //debugger
          var paramList = [];

          for (var i = 0; i < res.result.records.length; i++) {
            var param = res.result.records[i];
            param.key = param.id;
            param.editable = false;
            paramList.push(param);
          }

          _this.dataSource = paramList;
        } else {
          _this.$notification.warning({
            message: res.message
          });
        }

        _this.loading = false;
      });
    },
    handleChange: function handleChange(value, key, column) {
      var newData = _toConsumableArray(this.dataSource);

      var target = newData.filter(function (item) {
        return key === item.key;
      })[0];

      if (target) {
        target[column] = value;
        this.dataSource = newData;
      }
    },

    /**
     * 新增
     */
    addTable: function addTable() {
      var newData = _toConsumableArray(this.dataSource);

      this.disabled = false;
      newData.push({
        key: 'A1_' + this.addData1Index,
        method: 'add',
        dictId: this.dictId,
        itemText: '',
        itemValue: '',
        description: '',
        sortOrder: '',
        status: '1',
        editable: true
      });
      this.addData1Index = this.addData1Index + 1;
      this.dataSource = newData;
      this.cacheData1 = newData.map(function (item) {
        return _objectSpread({}, item);
      });
    },

    /**
     * table行输入保存
     * @param key
     */
    saveTable: function saveTable(key) {
      var _this2 = this;

      var newData = _toConsumableArray(this.dataSource);

      var target = newData.filter(function (item) {
        return key === item.key;
      })[0];

      if (target.itemText != null && target.itemText != '' && target.itemValue != null && target.itemValue != '') {
        delete target.editable;
        target.status = target.status.toString();
        var httpurl = '';
        var method = '';
        method = 'put';
        httpurl += this.url.edit;

        if (target.method != null && target.method == 'add') {
          httpurl = '';
          method = 'post';
          httpurl += this.url.add;
        }

        httpAction(httpurl, target, method).then(function (res) {
          if (res.success) {
            _this2.$notification.success({
              message: res.message
            });

            _this2.queryParam = {};

            _this2.loadData();

            _this2.dataSource = newData;
            _this2.cacheData1 = newData.map(function (item) {
              return _objectSpread({}, item);
            });
          } else {
            _this2.$notification.warning({
              message: res.message
            });
          }
        });
      } else {
        this.$message.warning('请填写字典项文本或字典项值');
      }

      this.editingKey = '';
    },

    /**
     * table行输入取消
     * @param key
     */
    cancelTable: function cancelTable(key) {
      var newData = _toConsumableArray(this.dataSource);

      var target = newData.filter(function (item) {
        return key === item.key;
      })[0];
      this.editingKey = '';

      if (target) {
        Object.assign(target, this.cacheData1.filter(function (item) {
          return key === item.key;
        })[0]);
        delete target.editable;
        this.dataSource = newData;
      }
    },

    /**
     * table行删除
     * @param key
     */
    delTable: function delTable(key) {
      var newData = this.dataSource.filter(function (item) {
        return key != item.key;
      });
      var docItem = this.dataSource.find(function (item) {
        return key == item.key;
      });

      if (docItem.id != null && docItem.id != '') {
        this.handleDelete(docItem.id);
      }

      this.dataSource = newData;
      this.cacheData1 = newData.map(function (item) {
        return _objectSpread({}, item);
      });
    },

    /**
     * table行编辑
     * @param key
     */
    editTable: function editTable(key) {
      this.disabled = true;

      var newData = _toConsumableArray(this.dataSource);

      var target = newData.filter(function (item) {
        return key === item.key;
      })[0];
      this.editingKey = key;

      if (target) {
        target.editable = true;
        this.dataSource = newData;
      }
    },
    openLink: function openLink(href) {
      window.open(href, '_blank');
    }
  }
};